import * as React from 'react';

import { Button, Divider, Grid, Typography, Card } from "@mui/material";
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import { useNavigate, useParams } from "react-router";

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

import { styled } from '@mui/material/styles';
import CameraAltIcon from '@mui/icons-material/CameraAlt';

import { resizeImageAuto } from '../../utils/resizeImgUtil';
import { useTablon } from '../../contexts/contextGeneral';
import imagenotfound from '../../image/Image-not-found.png';

const API_URL = "https://apiclimas.abdielaldana.com/";

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});

function EditOrden() {
    const { id } = useParams();
    const navigate = useNavigate();

    const {
        vehiculos,
        companias,
        usuarios,
        getDataCrearOrden,
        getOrden,
        putOrdenDatos,
        putConceptosOrden,
    } = useTablon();

    const [estatus, setEstatus] = React.useState(0);
    const [fechaHoy, setFechaHoy] = React.useState("");
    const [ot, setOt] = React.useState("");
    const [ot_externo, setOt_externo] = React.useState("");
    const [empresa, setEmpresa] = React.useState("");
    const [carro, setCarro] = React.useState("");
    const [elaboro, setElaboro] = React.useState("");
    const [observaciones, setObservaciones] = React.useState("");
    // const [kilometraje, setKilometraje] = React.useState("");

    const [guardandoOrden, setGuardandoOrden] = React.useState(false);
    const [guardandoConceptos, setGuardandoConceptos] = React.useState(false);

    const [busquedaVehiculo, setBusquedaVehiculo] = React.useState("");

    const [imageFileForm, setImageFileForm] = React.useState(null);
    const [previewVehiculoNuevo, setPreviewVehiculoNuevo] = React.useState(null);

    const [vehiculoNuevo, setVehiculoNuevo] = React.useState({
        placas: "",
        marca: "",
        modelo: "",
        color: "",
        vin: "",
        kilometraje: "",
    });

    const [companiaNueva, setCompaniaNueva] = React.useState({
        nombre: "",
    });

    const [conceptos, setConceptos] = React.useState([
        {
            id: null,
            cantidad: 1,
            concepto: "",
            precio_unitario: "",
            eliminado: false,
        }
    ]);

    React.useEffect(() => {
        cargarOrden();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    const limpiarFecha = (fecha) => {
        if (!fecha) return "";
        return String(fecha).substring(0, 10);
    };

    const cargarOrden = async () => {
        await getDataCrearOrden();

        const data = await getOrden(id);
        console.log("GET ORDEN COMPLETO:", data);

        if (!data) return;

        const ordenData = data.orden ?? data.data?.orden ?? data;
        const vehiculoData = data.vehiculo ?? data.data?.vehiculo ?? ordenData.vehiculo ?? {};
        const clienteData = data.cliente ?? data.compania ?? data.data?.cliente ?? ordenData.cliente ?? {};
        const conceptosData = data.conceptos ?? data.data?.conceptos ?? ordenData.conceptos ?? [];

        setFechaHoy(limpiarFecha(ordenData.fecha));
        setOt(ordenData.ot ?? "");
        setOt_externo(ordenData.ot_externo ?? "");

        setEmpresa(String(
            clienteData.id ??
            clienteData.compania_id ??
            ordenData.compania_id ??
            ""
        ));

        setCarro(String(
            vehiculoData.id ??
            vehiculoData.vehiculo_id ??
            ordenData.vehiculo_id ??
            ""
        ));

        setElaboro(String(
            ordenData.elaboro_id ??
            ordenData.usuario_id ??
            ordenData.elaboro?.id ??
            ""
        ));

        setEstatus(Number(ordenData.estatus ?? 0));
        setObservaciones(ordenData.observacion ?? ordenData.observaciones ?? "");
        // setKilometraje(ordenData.vehiculo.kilometraje ?? "");

        setImageFileForm(null);
        setPreviewVehiculoNuevo(null);

        if (conceptosData.length > 0) {
            setConceptos(
                conceptosData.map(item => ({
                    id: item.id ?? null,
                    cantidad: item.cantidad ?? 1,
                    concepto: item.concepto ?? "",
                    precio_unitario: item.precio_unitario ?? "",
                    eliminado: false,
                }))
            );
        }
    };

    const returnOrders = () => {
        navigate("/ordenes");
    };

    const handleVehiculoNuevo = (campo, valor) => {
        setVehiculoNuevo(prev => ({
            ...prev,
            [campo]: valor,
        }));
    };

    const handleCompaniaNueva = (campo, valor) => {
        setCompaniaNueva(prev => ({
            ...prev,
            [campo]: valor,
        }));
    };

    const handleImageVehiculoNuevo = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const optimized = await resizeImageAuto(file);
        setImageFileForm(optimized);

        const reader = new FileReader();
        reader.onloadend = () => {
            setPreviewVehiculoNuevo(reader.result);
        };
        reader.readAsDataURL(optimized);
    };

    const agregarConcepto = () => {
        setConceptos(prev => [
            ...prev,
            {
                id: null,
                cantidad: 1,
                concepto: "",
                precio_unitario: "",
                eliminado: false,
            }
        ]);
    };

    const eliminarConcepto = (index) => {
        setConceptos(prev => {
            const concepto = prev[index];

            if (!concepto.id) {
                return prev.filter((_, i) => i !== index);
            }

            return prev.map((item, i) =>
                i === index
                    ? { ...item, eliminado: true }
                    : item
            );
        });
    };

    const restaurarConcepto = (index) => {
        setConceptos(prev =>
            prev.map((item, i) =>
                i === index
                    ? { ...item, eliminado: false }
                    : item
            )
        );
    };

    const cambiarConcepto = (index, campo, valor) => {
        setConceptos(prev =>
            prev.map((item, i) =>
                i === index
                    ? { ...item, [campo]: valor }
                    : item
            )
        );
    };

    const guardarDatosOrden = async () => {
        setGuardandoOrden(true);

        const formDataPayload = new FormData();

        const payload = {
            orden: {
                fecha: fechaHoy,
                ot: ot,
                ot_externo: ot_externo,
                elaboro_id: elaboro,
                vehiculo_id: carro !== "0" ? carro : null,
                compania_id: empresa !== "0" ? empresa : null,
                observacion: observaciones,
                estatus: estatus,
            },
            vehiculo_nuevo: carro === "0" ? vehiculoNuevo : null,
            compania_nueva: empresa === "0" ? companiaNueva : null,
        };

        console.log("PAYLOAD ORDEN:", payload);

        formDataPayload.append("data", JSON.stringify(payload));

        if (carro === "0" && imageFileForm) {
            formDataPayload.append("imagen_vehiculo", imageFileForm);
        }

        try {
            const res = await putOrdenDatos(id, formDataPayload);

            if (res?.ok) {
                await cargarOrden();
            }
        } catch (err) {
            console.error(err);
        } finally {
            setGuardandoOrden(false);
        }
    };

    const guardarConceptos = async () => {
        setGuardandoConceptos(true);

        const formDataPayload = new FormData();

        const payload = {
            conceptos: conceptos.map(item => ({
                id: item.id ?? null,
                cantidad: Number(item.cantidad || 1),
                concepto: item.concepto,
                precio_unitario: Number(item.precio_unitario || 0),
                eliminado: Boolean(item.eliminado),
            }))
        };

        console.log("PAYLOAD CONCEPTOS:", payload);

        formDataPayload.append("data", JSON.stringify(payload));

        try {
            const res = await putConceptosOrden(id, formDataPayload);

            if (res?.ok) {
                await cargarOrden();
            }
        } catch (err) {
            console.error(err);
        } finally {
            setGuardandoConceptos(false);
        }
    };

    const vehiculosFiltrados = busquedaVehiculo.trim()
        ? vehiculos.filter((v) =>
            String(v.placas).toLowerCase().startsWith(busquedaVehiculo.toLowerCase())
        )
        : vehiculos.slice(-5);

    const vehiculoSeleccionado = vehiculos.find(v => Number(v.id) === Number(carro));

    const srcVehiculoSeleccionado = vehiculoSeleccionado?.ruta
        ? API_URL + vehiculoSeleccionado.ruta
        : imagenotfound;

    return (
        <>
            <Grid container spacing={2}>
                <Grid size={{ xs: 12, md: 12 }}>
                    <Typography variant='body1' color='warning' onClick={returnOrders} sx={{ cursor: "pointer" }}>
                        Regresar a Ordenes
                    </Typography>

                    <center>
                        <Typography variant='h6' color='primary'>Editar Información</Typography>
                        <Typography variant='h4' color='primary'><b>Orden {ot}</b></Typography>
                    </center>
                </Grid>

                <Grid size={{ xs: 12, md: 12 }}>
                    <Divider />
                </Grid>
            </Grid>

            <Card sx={{ padding: "20px 10px", margin: '10px 0' }}>
                <Grid container spacing={2}>
                    <Grid size={{ xs: 12, md: 12 }}>
                        <center>
                            <Typography variant='h5' color='primary'>
                                <b>Cliente de la Orden</b>
                            </Typography>
                        </center>
                    </Grid>

                    <Grid size={{ xs: 12, md: 12 }}>
                        <FormControl fullWidth>
                            <InputLabel id="label-cliente">Cliente</InputLabel>
                            <Select
                                labelId="label-cliente"
                                id="cliente"
                                name="cliente"
                                value={String(empresa)}
                                label="Cliente"
                                onChange={(e) => setEmpresa(e.target.value)}
                            >
                                <MenuItem value="0">Nueva compañía</MenuItem>
                                {companias.map((item) => (
                                    <MenuItem value={String(item.id)} key={item.id}>
                                        {item.nombre}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>

                    {empresa === "0" && (
                        <Grid size={{ xs: 12, md: 12 }}>
                            <TextField
                                label="Nombre de la nueva compañía"
                                fullWidth
                                value={companiaNueva.nombre}
                                onChange={(e) => handleCompaniaNueva("nombre", e.target.value)}
                            />
                        </Grid>
                    )}
                </Grid>
            </Card>

            <Card sx={{ padding: "20px 10px", margin: '10px 0' }}>
                <Grid container spacing={2}>
                    <Grid size={{ xs: 12, md: 12 }}>
                        <center>
                            <Typography variant='h5' color='primary'>
                                <b>Vehículo de la Orden</b>
                            </Typography>
                        </center>
                    </Grid>

                    <Grid size={{ xs: 12, md: 6 }}>
                        <TextField
                            label="Buscar por placas"
                            value={busquedaVehiculo}
                            fullWidth
                            onChange={(e) => setBusquedaVehiculo(e.target.value)}
                        />
                    </Grid>

                    <Grid size={{ xs: 12, md: 6 }}>
                        <Typography variant='body1' color={busquedaVehiculo.trim() ? "success" : "error"}>
                            <center>
                                {busquedaVehiculo.trim()
                                    ? "Coincidencias " + vehiculosFiltrados.length
                                    : "Se muestran los ultimos 5 vehículos"}
                            </center>
                        </Typography>
                    </Grid>

                    <Grid size={{ xs: 12, md: 12 }}>
                        <FormControl fullWidth>
                            <InputLabel id="label-vehiculo">Vehículos</InputLabel>
                            <Select
                                labelId="label-vehiculo"
                                id="carro"
                                name="carro"
                                value={String(carro)}
                                label="Vehículos"
                                onChange={(e) => setCarro(e.target.value)}
                            >
                                <MenuItem value="0">Nuevo vehículo</MenuItem>
                                {vehiculosFiltrados.map((item) => (
                                    <MenuItem value={String(item.id)} key={item.id}>
                                        {item.placas}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>

                    {carro === "0" && (
                        <>
                            <Grid size={{ xs: 12, md: 12 }}>
                                <Divider sx={{ margin: "10px 0" }} />
                            </Grid>

                            <Grid size={{ xs: 12, md: 12 }}>
                                <Typography variant='h6' color='primary'>
                                    <b>Nuevo vehículo</b>
                                </Typography>
                            </Grid>

                            <Grid size={{ xs: 12, md: 4 }} className="centerH">
                                <div className="imagenVehiculo">
                                    <img
                                        src={previewVehiculoNuevo || imagenotfound}
                                        alt="Nuevo vehículo"
                                        width="100%"
                                    />
                                </div>
                            </Grid>

                            <Grid size={{ xs: 12, md: 8 }}>
                                <Grid container spacing={2}>
                                    <Grid size={{ xs: 12, md: 6 }}>
                                        <TextField
                                            label="Placas"
                                            fullWidth
                                            value={vehiculoNuevo.placas}
                                            onChange={(e) => handleVehiculoNuevo("placas", e.target.value)}
                                        />
                                    </Grid>

                                    <Grid size={{ xs: 12, md: 6 }}>
                                        <TextField
                                            label="Marca"
                                            fullWidth
                                            value={vehiculoNuevo.marca}
                                            onChange={(e) => handleVehiculoNuevo("marca", e.target.value)}
                                        />
                                    </Grid>

                                    <Grid size={{ xs: 12, md: 6 }}>
                                        <TextField
                                            label="Modelo"
                                            fullWidth
                                            value={vehiculoNuevo.modelo}
                                            onChange={(e) => handleVehiculoNuevo("modelo", e.target.value)}
                                        />
                                    </Grid>

                                    <Grid size={{ xs: 12, md: 6 }}>
                                        <TextField
                                            label="Color"
                                            fullWidth
                                            value={vehiculoNuevo.color}
                                            onChange={(e) => handleVehiculoNuevo("color", e.target.value)}
                                        />
                                    </Grid>

                                    <Grid size={{ xs: 12, md: 6 }}>
                                        <TextField
                                            label="VIN"
                                            fullWidth
                                            value={vehiculoNuevo.vin}
                                            onChange={(e) => handleVehiculoNuevo("vin", e.target.value)}
                                        />
                                    </Grid>

                                    <Grid size={{ xs: 12, md: 6 }}>
                                        <TextField
                                            label="Kilometraje del vehículo"
                                            fullWidth
                                            value={vehiculoNuevo.kilometraje}
                                            onChange={(e) => handleVehiculoNuevo("kilometraje", e.target.value)}
                                        />
                                    </Grid>

                                    <Grid size={{ xs: 12, md: 12 }}>
                                        <Button
                                            component="label"
                                            tabIndex={-1}
                                            size="small"
                                            color={imageFileForm ? "secondary" : "primary"}
                                            variant="contained"
                                            startIcon={<CameraAltIcon />}
                                            fullWidth
                                        >
                                            {imageFileForm ? "Imagen cargada" : "Agregar imagen del vehículo"}
                                            <VisuallyHiddenInput
                                                type="file"
                                                accept="image/*"
                                                onChange={handleImageVehiculoNuevo}
                                                name="imagen_vehiculo"
                                            />
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </>
                    )}

                    {carro !== "0" && vehiculoSeleccionado && (
                        <Grid size={{ xs: 12, md: 12 }}>
                            <Card sx={{ padding: "10px 20px" }}>
                                <Grid container spacing={2}>
                                    <Grid size={{ xs: 12, md: 4 }} className="centerH">
                                        <div className="imagenVehiculo">
                                            <img
                                                src={srcVehiculoSeleccionado}
                                                alt={"Vehículo " + vehiculoSeleccionado.placas}
                                                width="100%"
                                            />
                                        </div>
                                    </Grid>

                                    <Grid size={{ xs: 12, md: 8 }}>
                                        <Typography variant="body1" noWrap>
                                            Placas: <b>{vehiculoSeleccionado.placas}</b>
                                        </Typography>
                                        <Typography variant="body1" noWrap>
                                            Modelo: <b>{vehiculoSeleccionado.marca} {vehiculoSeleccionado.modelo}</b>
                                        </Typography>
                                        <Typography variant="body1" noWrap>
                                            Color: <b>{vehiculoSeleccionado.color}</b>
                                        </Typography>
                                        <Typography variant="body1" noWrap>
                                            Kilometraje: <b>{vehiculoSeleccionado.kilometraje} km</b>
                                        </Typography>
                                        <Typography variant="body1" noWrap>
                                            VIN: <b>{vehiculoSeleccionado.vin}</b>
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Card>
                        </Grid>
                    )}
                </Grid>
            </Card>

            <Card sx={{ padding: "20px 10px", margin: '10px 0' }}>
                <Grid container spacing={2}>
                    <Grid size={{ xs: 12, md: 12 }}>
                        <center>
                            <Typography variant='h5' color='primary'>
                                <b>Datos de la Orden</b>
                            </Typography>
                        </center>
                    </Grid>

                    <Grid size={{ xs: 12, md: 6 }}>
                        <TextField
                            id="fechaHoy"
                            name="fechaHoy"
                            label="Fecha"
                            variant="outlined"
                            type='date'
                            fullWidth
                            value={fechaHoy}
                            onChange={(e) => setFechaHoy(e.target.value)}
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>

                    <Grid size={{ xs: 12, md: 6 }}>
                        <TextField
                            id="ot_externo"
                            name="ot_externo"
                            label="OT Externo"
                            variant="outlined"
                            fullWidth
                            value={ot_externo}
                            onChange={(e) => setOt_externo(e.target.value)}
                        />
                    </Grid>

                    <Grid size={{ xs: 12, md: 6 }}>
                        <FormControl fullWidth>
                            <InputLabel id="label-elaboro">Elaboró</InputLabel>
                            <Select
                                labelId="label-elaboro"
                                id="elaboro"
                                name="elaboro"
                                value={String(elaboro)}
                                label="Elaboró"
                                onChange={(e) => setElaboro(e.target.value)}
                            >
                                {usuarios.map((elem) => (
                                    <MenuItem value={String(elem.id)} key={elem.id}>
                                        {elem.nombre}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid size={{ xs: 12, md: 6 }}>
                        <FormControl fullWidth>
                            <InputLabel id="label-estatus">Estatus</InputLabel>
                            <Select
                                labelId="label-estatus"
                                id="estatus"
                                name="estatus"
                                value={Number(estatus)}
                                label="Estatus"
                                onChange={(e) => setEstatus(Number(e.target.value))}
                            >
                                <MenuItem value={0}>Pendiente</MenuItem>
                                <MenuItem value={1}>Terminada</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>

                    {/* <Grid size={{ xs: 12, md: 6 }}>
                        <TextField
                            id="kilo"
                            name="kilo"
                            label="Kilometraje de la orden"
                            variant="outlined"
                            fullWidth
                            value={kilometraje}
                            onChange={(e) => setKilometraje(e.target.value)}
                        />
                    </Grid> */}

                    <Grid size={{ xs: 12, md: 12 }}>
                        <TextField
                            id="observaciones"
                            name="observaciones"
                            label="Observaciones"
                            variant="outlined"
                            fullWidth
                            multiline
                            rows={4}
                            value={observaciones}
                            onChange={(e) => setObservaciones(e.target.value)}
                        />
                    </Grid>

                    <Grid size={{ xs: 12, md: 12 }}>
                        <Button
                            variant="contained"
                            color="success"
                            fullWidth
                            onClick={guardarDatosOrden}
                            disabled={guardandoOrden}
                        >
                            Guardar datos de orden
                        </Button>
                    </Grid>
                </Grid>
            </Card>



            <Card sx={{ padding: "20px 10px", margin: '10px 0' }}>
                <Grid container spacing={2}>
                    <Grid size={{ xs: 12, md: 12 }}>
                        <center>
                            <Typography variant='h5' color='primary'>
                                <b>Conceptos</b>
                            </Typography>
                        </center>
                    </Grid>

                    {conceptos.map((item, index) => (
                        <Grid size={{ xs: 12, md: 12 }} key={index}>
                            <Card
                                sx={{
                                    padding: "15px",
                                    marginBottom: "10px",
                                    opacity: item.eliminado ? 0.5 : 1,
                                }}
                            >
                                <Grid container spacing={2}>
                                    {item.eliminado && (
                                        <Grid size={{ xs: 12, md: 12 }}>
                                            <Typography color="error">
                                                Este concepto se eliminará al guardar.
                                            </Typography>
                                        </Grid>
                                    )}

                                    <Grid size={{ xs: 6, md: 3 }}>
                                        <TextField
                                            label="Cantidad"
                                            type="number"
                                            fullWidth
                                            value={item.cantidad}
                                            onChange={(e) => cambiarConcepto(index, "cantidad", e.target.value)}
                                            inputProps={{ min: 1, step: "0.01" }}
                                            disabled={item.eliminado}
                                        />
                                    </Grid>

                                    <Grid size={{ xs: 6, md: 3 }}>
                                        <TextField
                                            label="Precio"
                                            type="number"
                                            fullWidth
                                            value={item.precio_unitario}
                                            onChange={(e) => cambiarConcepto(index, "precio_unitario", e.target.value)}
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">$</InputAdornment>
                                                )
                                            }}
                                            inputProps={{ min: 0, step: "0.01" }}
                                            disabled={item.eliminado}
                                        />
                                    </Grid>

                                    <Grid size={{ xs: 12, md: 6 }}>
                                        <TextField
                                            label="Concepto"
                                            fullWidth
                                            multiline
                                            minRows={2}
                                            value={item.concepto}
                                            onChange={(e) => cambiarConcepto(index, "concepto", e.target.value)}
                                            disabled={item.eliminado}
                                        />
                                    </Grid>

                                    <Grid size={{ xs: 12, md: 12 }} className="centerE">
                                        {item.eliminado ? (
                                            <Button
                                                variant="outlined"
                                                color="primary"
                                                size="small"
                                                onClick={() => restaurarConcepto(index)}
                                            >
                                                Restaurar concepto
                                            </Button>
                                        ) : (
                                            <Button
                                                variant="outlined"
                                                color="error"
                                                size="small"
                                                onClick={() => eliminarConcepto(index)}
                                                disabled={conceptos.length === 1 && !item.id}
                                            >
                                                Eliminar concepto
                                            </Button>
                                        )}
                                    </Grid>
                                </Grid>
                            </Card>
                        </Grid>
                    ))}

                    <Grid size={{ xs: 12, md: 12 }}>
                        <Button
                            variant="contained"
                            color="primary"
                            fullWidth
                            onClick={agregarConcepto}
                        >
                            Agregar concepto
                        </Button>
                    </Grid>

                    <Grid size={{ xs: 12, md: 12 }}>
                        <Button
                            variant="contained"
                            color="success"
                            fullWidth
                            onClick={guardarConceptos}
                            disabled={guardandoConceptos}
                        >
                            Guardar conceptos
                        </Button>
                    </Grid>
                </Grid>
            </Card>
        </>
    );
}

export default EditOrden;
